import { render, staticRenderFns } from "./OrderCheck.vue?vue&type=template&id=1c63eb18&"
import script from "./OrderCheck.vue?vue&type=script&lang=ts&"
export * from "./OrderCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports